import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanAdditionalPDFDetails } from 'src/app/models/plan-additional-pdfdetails';
import { PlanDetails } from 'src/app/models/plan-details';
import { DrugSearchURLService } from 'src/app/services/drug-search-url.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-plan-details',
  templateUrl: './plan-details.component.html',
  styleUrls: ['./plan-details.component.scss']
})
export class PlanDetailsComponent implements OnInit {

  url: string;
  uuid: string;
  planDetails: PlanDetails;
  imageData: any;
  sanitizedImageData: any;
  @ViewChild('urlBodyText') urlBodyText: ElementRef;
  showAlert: boolean;
  alertMessage: string;
  isSearchByDrug: boolean = true;
  otherPDFDetailsList = new Array<PlanAdditionalPDFDetails>();
  pdfDetailsList = new Array<number>();
  planAdditionalPDFDetails = new PlanAdditionalPDFDetails();
  showView = false;
  ssncLoaderColor = '#1976d2';
  @Output() invalidPlanEvent = new EventEmitter<string>();
  subs = new SubSink();
  externalPDFList = new Array<string>();

  constructor(private _drugSearchURLService: DrugSearchURLService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.showAlert = false;
     this.route.queryParams.subscribe(params => {
       this.uuid= params.planid;
       if (this.uuid) {
   this.getPlanDetails();
  }
     })
    this.isSearchByDrug = true;
   // this.uuid = '5dbfe4ef-77c2-4bd4-b8de-c4be05ed2a4c';
   //this.getPlanDetails();
  }

  getPlanDetails() {
    this.subs.add(this._drugSearchURLService.getPlanDetails(this.uuid).subscribe((response) => {
        this.planDetails = response.data[0];
        this._drugSearchURLService.planDetails = this.planDetails;
        this.imageData = 'data:image/png;base64,' + this.planDetails.planLogo;
        this.urlBodyText.nativeElement.innerHTML = this.planDetails.urlBodyText;
        this.otherPDFDetailsList = new Array<PlanAdditionalPDFDetails>();
        this.pdfDetailsList = new Array<number>();
        for (let planAdditionalPDFDetails of this.planDetails.planAdditionalPDFDetailsList) {
          this.planAdditionalPDFDetails = new PlanAdditionalPDFDetails();
          this.planAdditionalPDFDetails.additionalPDFClassificationId =planAdditionalPDFDetails.additionalPDFClassificationId;
          this.planAdditionalPDFDetails.additionalPDFClassificationName = planAdditionalPDFDetails.additionalPDFClassificationName;
          this.planAdditionalPDFDetails.additionalPDFClassificationFullName = planAdditionalPDFDetails.additionalPDFClassificationFullName;
          this.planAdditionalPDFDetails.planId = planAdditionalPDFDetails.planId;
          if (planAdditionalPDFDetails.additionalPDFClassificationId === 0 || planAdditionalPDFDetails.additionalPDFClassificationId === -1 || planAdditionalPDFDetails.additionalPDFClassificationId === 24 || planAdditionalPDFDetails.additionalPDFClassificationId === 28 || planAdditionalPDFDetails.additionalPDFClassificationId === 5 || planAdditionalPDFDetails.additionalPDFClassificationId === 25) {
            this.pdfDetailsList.push(this.planAdditionalPDFDetails.additionalPDFClassificationId);
          } else {
            this.otherPDFDetailsList.push(this.planAdditionalPDFDetails);
            this.otherPDFDetailsList = this.otherPDFDetailsList.sort(function (a, b) {
              return a.additionalPDFClassificationFullName.localeCompare(b.additionalPDFClassificationFullName);
            });
          }
        }
        this.externalPDFList = new Array<string>();
        this.externalPDFList = this.planDetails.externalPDFList;
        this.showView = true;
      }));
  }

  recieveErrorEvent(event) {
    this.invalidPlanEvent.emit(event);
  }

  fetchPDFReport(planId, reportType) {
    reportType = reportType.replace(/\s/g, "");
    this._drugSearchURLService.fetchPDFReport(planId, reportType);
  }

  fetchExternalPDFReport(planId, externalPDF) {
    this._drugSearchURLService.fetchExternalPDFReport(planId, externalPDF);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
